"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const formik_1 = require("formik");
const react_core_1 = require("@patternfly/react-core");
const utils_1 = require("./utils");
const featureSupportLevels_1 = require("../../featureSupportLevels");
const use_translation_wrapper_1 = require("../../../hooks/use-translation-wrapper");
const SingleNodeCheckbox = (_a) => {
    var { versions, validate, idPostfix } = _a, props = tslib_1.__rest(_a, ["versions", "validate", "idPostfix"]);
    const { values: { openshiftVersion }, } = (0, formik_1.useFormikContext)();
    const [field, meta, helpers] = (0, formik_1.useField)({ name: props.name, validate });
    const featureSupportLevelContext = (0, featureSupportLevels_1.useFeatureSupportLevel)();
    const prevVersionRef = React.useRef(openshiftVersion);
    const fieldId = (0, utils_1.getFieldId)(props.name, 'input', idPostfix);
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    const { value } = meta;
    const { setValue } = helpers;
    const isSupportedVersionAvailable = !!versions.find((version) => featureSupportLevelContext.isFeatureSupported(version.value, 'SNO'));
    const onChanged = React.useCallback((checked) => setValue(checked ? 'None' : 'Full'), [setValue]);
    const disabledReason = featureSupportLevelContext.getFeatureDisabledReason(openshiftVersion, 'SNO', t);
    React.useEffect(() => {
        if (prevVersionRef.current !== openshiftVersion &&
            !featureSupportLevelContext.isFeatureSupported(openshiftVersion, 'SNO')) {
            //invoke updating SNO value only if the version changed to not be in danger of touching existing clusters
            onChanged(false);
        }
        prevVersionRef.current = openshiftVersion;
    }, [openshiftVersion, onChanged, featureSupportLevelContext]);
    if (isSupportedVersionAvailable) {
        return (React.createElement(react_core_1.FormGroup, { isInline: true, fieldId: fieldId },
            React.createElement(react_core_1.Tooltip, { hidden: !disabledReason, content: disabledReason },
                React.createElement(react_core_1.Checkbox, Object.assign({}, field, props, { id: fieldId, label: React.createElement(React.Fragment, null,
                        t('ai:Install single node OpenShift (SNO)'),
                        "\u00A0",
                        React.createElement(featureSupportLevels_1.FeatureSupportLevelBadge, { featureId: "SNO", openshiftVersion: openshiftVersion })), "aria-describedby": `${fieldId}-helper`, description: React.createElement(react_core_1.FormGroup, null,
                        React.createElement(react_core_1.FormHelperText, null,
                            React.createElement(react_core_1.HelperText, { id: fieldId },
                                React.createElement(react_core_1.HelperTextItem, null, t('ai:SNO enables you to install OpenShift using only one host.'))))), isChecked: value === 'None', onChange: (_event, value) => onChanged(value), className: "with-tooltip" })))));
    }
    return null;
};
exports.default = SingleNodeCheckbox;
//# sourceMappingURL=SingleNodeCheckbox.js.map